import { useLingui } from '@lingui/react';
import { formatMoneyFixed } from '@wkda/funnel-utils';
import { CheveronRightIcon } from '@wkda/icons';
import { Button } from '@wkda/styleguide';
import cx from 'classnames';
import { useCallback, useEffect } from 'react';
import { useCarleadConfiguration } from '../../../hooks/useCarleadCreationConfiguration';
import { useCarleadDataLayer } from '../../../hooks/useCarleadDataLayer';
import { BenefitsList } from './BenefitsList';
import { useTrackCustomerBanner } from '@wkda/funnel-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function L2ASelfEvaluation(_ref) {
  let {
    marketingExperiment,
    offerPrice,
    manufacturer,
    model,
    inspectionUrl
  } = _ref;
  const {
    i18n: _i18n
  } = useLingui();
  const dataLayer = useCarleadDataLayer();
  const noPriceMarketingProperty = marketingExperiment === null || marketingExperiment === void 0 ? void 0 : marketingExperiment.selfEvaHideOnlinePrice;
  const {
    locale
  } = useCarleadConfiguration();
  const {
    trackShownEvent,
    trackCTAClickEvent,
    getCJTrackingButtonNameByAttr
  } = useTrackCustomerBanner();
  const formattedOfferPrice = formatMoneyFixed(locale, offerPrice !== null && offerPrice !== void 0 ? offerPrice : 0);
  const benefitsTranslations = ['carleadCreation.l2aSelfEvaluationRCB.benefitsList.first', 'carleadCreation.l2aSelfEvaluationRCB.benefitsList.second', 'carleadCreation.l2aSelfEvaluationRCB.benefitsList.third'];
  useEffect(() => {
    dataLayer.pushCustomerBannerOpen('lead-to-appointment');
    trackShownEvent('lead-to-appointment');
  }, [dataLayer, trackShownEvent]);
  const handleButtonClick = useCallback(e => {
    const ctaName = getCJTrackingButtonNameByAttr(e.currentTarget);
    if (ctaName) {
      trackCTAClickEvent('lead-to-appointment', ctaName);
    }
  }, [getCJTrackingButtonNameByAttr, trackCTAClickEvent]);
  return /*#__PURE__*/_jsx("div", {
    className: "container l2a-self-evaluation-rcb",
    children: /*#__PURE__*/_jsxs("div", {
      className: "row justify-content-center",
      children: [/*#__PURE__*/_jsx("div", {
        className: cx('col-md-4', {
          'd-none': noPriceMarketingProperty
        }),
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("div", {
            className: "l2a-self-evaluation-rcb__title",
            children: offerPrice ? _i18n._('carleadCreation.l2aSelfEvaluationRCB.priceTitle', {
              manufacturer,
              model
            }) : _i18n._('carleadCreation.l2aSelfEvaluationRCB.noPriceTitle')
          }), /*#__PURE__*/_jsx("div", {
            className: "banner-return-customer__price l2a-self-evaluation-rcb__price",
            children: formattedOfferPrice
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "col-md-4 text-center",
        children: [/*#__PURE__*/_jsx("div", {
          className: "l2a-self-evaluation-rcb__title d-none d-md-block font-weight-bold",
          children: _i18n._('carleadCreation.l2aSelfEvaluationRCB.title')
        }), /*#__PURE__*/_jsx(Button, {
          "data-cj-tracking-button-name": "view-inspection-button",
          component: "a",
          variant: "secondary",
          href: inspectionUrl,
          onClick: handleButtonClick,
          children: /*#__PURE__*/_jsxs("div", {
            className: "d-flex justify-content-center align-items-center",
            children: [/*#__PURE__*/_jsx("span", {
              className: "d-lg-none",
              children: _i18n._('carleadCreation.l2aSelfEvaluationRCB.bookingTitleShort')
            }), /*#__PURE__*/_jsx("span", {
              className: "d-none d-lg-block",
              children: _i18n._('carleadCreation.l2aSelfEvaluationRCB.bookingTitleFull')
            }), /*#__PURE__*/_jsx(CheveronRightIcon, {
              className: "ml-2"
            })]
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "col-sm-4 l2a-self-evaluation-rcb__col-3 d-none d-md-block",
        children: /*#__PURE__*/_jsx(BenefitsList, {
          classNameRowText: "l2a-self-evaluation-rcb__list-item-text",
          benefitsTranslations: benefitsTranslations
        })
      })]
    })
  });
}